const config = {
    type: 'MULTIMEDIA',
    component: "Smu01",
    portrait: "/img/container/S-MU-01.jpg",
    body: {
        title:"",
        content: ""
    }
}

export {config}